import ProductImage from '@assets/png/product.png';
import { Image } from '@mantine/core';
import { KnownProductType } from '@store/redux/features/inventory/knownData';
import { RootState } from '@store/redux/store';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { FlattenSingle } from './inputs/types';
import { ContainerColumn, Label, ProductName, SerialName } from './styles';

interface EquipmentViewProps extends FlattenSingle<'productId' | 'serial'> {
  groupEdits: boolean;
}
function EquipmentView(props: EquipmentViewProps) {
  const { groupEdits, productId, serial } = props;

  const product: Partial<KnownProductType> =
    useSelector(
      (state: RootState) =>
        state.knownData.knownProducts[productId ?? ''] as
          | KnownProductType
          | undefined,
    ) || {};
  return (
    <Label>
      <Image
        width={32}
        height={32}
        src={product?.imageUrl}
        withPlaceholder
        placeholder={
          <Image
            withPlaceholder
            src={product?.manufacturerImg}
            width={32}
            height={32}
            placeholder={<Image src={ProductImage} width={32} height={32} />}
          />
        }
      />

      <ContainerColumn>
        <SerialName isDisabled={!serial || groupEdits}>
          {serial || 'No Serial #'}
        </SerialName>
        <ProductName isDisabled={!product?.model || groupEdits}>
          {product?.model ? product?.model : 'Unknown'}
        </ProductName>
      </ContainerColumn>
    </Label>
  );
}
export default memo(EquipmentView);
